import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { MAX_WIDTH_SEMI_XL } from '@/utils/constants';

import ArrowDirectionsIcon, { ARROW_DIRECTIONS } from '../ArrowDirectionsIcon';

import useStyles from './ResizeButton.styles';

interface IResizeButtonProps {
  onConfigChange: (config: string) => void;
  className?: string;
}

const WIDTHS = {
  initial: '100%',
  middle: '70vw',
  large: 'calc(100vw - 156px)',
};

const CONFIG_WIDTH = [WIDTHS.large, WIDTHS.initial];
const CONFIG_XL_WIDTH = [WIDTHS.large, WIDTHS.initial];

const ResizeButton = ({ onConfigChange, className = '' }: IResizeButtonProps) => {
  const [configIndex, setConfigIndex] = useState(0);
  const [isLastOption, setIsLastOption] = useState(false);
  const [configWidth, setConfigWidth] = useState(CONFIG_WIDTH);
  const isExtraLargeScreen = useMediaQuery(`(min-width:${MAX_WIDTH_SEMI_XL}px)`);
  const classes = useStyles();

  useEffect(() => {
    onConfigChange(configWidth[configIndex]);
    setIsLastOption(configIndex === configWidth.length - 1);
  }, [configIndex, onConfigChange, setIsLastOption, configWidth]);

  useEffect(() => {
    if (isExtraLargeScreen) {
      setConfigWidth(CONFIG_XL_WIDTH);
    } else {
      setConfigWidth(CONFIG_WIDTH);
    }
  }, [isExtraLargeScreen]);

  const handleButtonClick = () => {
    setConfigIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      if (nextIndex < configWidth.length) return nextIndex;
      return 0;
    });
  };

  return (
    <button
      className={`${className} ${classes.resizeButton}`}
      aria-label="resize button"
      data-testid="qa-powerapps-resize-button"
      type="submit"
      onClick={handleButtonClick}
    >
      <div className={classes.leftArrowWrapper}>
        <ArrowDirectionsIcon
          direction={isLastOption ? ARROW_DIRECTIONS.right : ARROW_DIRECTIONS.left}
        />
      </div>
      <div className={classes.rightArrowWrapper}>
        <ArrowDirectionsIcon
          direction={isLastOption ? ARROW_DIRECTIONS.left : ARROW_DIRECTIONS.right}
        />
      </div>
    </button>
  );
};

export default ResizeButton;
